<template>
	<div>
		<v-btn
			v-if="type==='choose'"
			class="mb-2"
			small
		>
			<v-icon class="ml-1">
				mdi-camera
			</v-icon>
			<span>בחירת תמונה</span>
		</v-btn>
		<v-btn
			v-if="type === 'remove'"
			color="red"
			small
		>
			<v-icon class="ml-1">
				mdi-trash-can
			</v-icon>
			<span>הסרת תמונה</span>
		</v-btn>
	</div>
</template>

<script>
export default {
	name: "MediaGalleryBtn",
	props: {
		type: { type: String, default: "choose" },
	},

};
</script>

<style scoped>

</style>
